import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import type { ReactElement } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Typography } from "@mui/material";

interface TabItem {
  label?: string;
  value: string;
  icon?: ReactElement;
  content: React.ReactNode;
}

interface ScrollableTabsProps {
  tabs: TabItem[];
}

export default function ScrollableWrestlerTabs({ tabs }: ScrollableTabsProps) {
  const [value, setValue] = React.useState<string>(tabs?.[0]?.value || "");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        color: "#ffffff",
        margin: "0 25px",
      }}
    >
      <TabContext value={value}>
        <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",      
    }}
  >
   {/* <Typography
      sx={{
        color: "#fff",
        fontWeight: 500,
        ml: 2,
        whiteSpace: "nowrap",
      }}
    >
      Featured Wrestlers
    </Typography> */}

        <TabList
          onChange={handleChange}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="styled tabs"
          sx={{
            "& .MuiTabs-flexContainer": {
              justifyContent: isSmallScreen ? "flex-start" : "flex-start",
            },
            "& .MuiTabs-scroller": {
              overflowX: "auto !important",
              scrollBehavior: "auto",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#FFD700",
              height: 3,
              borderRadius: "2px",
              display: "none",
            },
            "& .MuiTabScrollButton-root": {
              opacity: 1,
              backgroundColor: "#141414",
              color: "#fff", // optional (arrow color)
              borderRadius: "100px",
              height: "30px",
              width: "30px",
              top: "20px",
            },
            "& .Mui-disabled": {
              opacity: '0.3 !important',              // 👈 faded when cannot scroll
            },
          }}
        >

          

          {tabs.map((tab) => (
            <Tab
              key={tab.value}
              label={
                <Box
                  sx={{
                    // borderRight: "1px solid #333",
                    px: 2,
                    "&:last-child": {
                      borderRight: "none",
                    },
                  }}
                >
                  {tab.label}
                </Box>
              }
              value={tab.value}
              icon={tab.icon}
              iconPosition="top"
              sx={{
                textTransform: "none",
                color: "#aaa",
                fontWeight: 300,
                fontSize: '12px',
                px: 0,
                mx: 0.5,
                "&.Mui-selected": {
                  color: "#fff",
                  fontWeight: 300,
                  "&:hover": {
                    color: "#bf80ec",
                  },
                },
                "& .MuiTab-iconWrapper": {
                  color: "#aaa",
                  mb: "2px",
                  "&.Mui-selected": {
                    color: "#fff",
                  },
                },
              }}
            />
          ))}
        </TabList>
        
  </Box>

        {/* Tab Panels */}
        {tabs.map((tab) => (
          <TabPanel
            key={tab.value}
            value={tab.value}
            sx={{
              color: "#acacac",
              p: 0,
            }}
          >
            {tab.content}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
}
